module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-bar2-68400f544c2b263fb6174df5569a142a.svg";